import BaseAppStarter from '@src/page/toc/common/base-app-starter';
import 'core-js/modules/es.symbol.async-iterator';
import 'reflect-metadata';
import '@src/slide/domain/slide-app/entry/entry';
import { RUNTIME } from '@src/slide/infrastructure/module/dependent/config/tob/constant';

declare global {
    interface Window {
        console: { dev: (msg) => void };
    }
}

export default abstract class CommonAppStarter extends BaseAppStarter {
    protected initAppUI() {
        window.hostname = RUNTIME.DOMAIN_NAME;

        // eslint-disable-next-line no-undef
        if (process.env.NODE_ENV !== 'production') {
            window.console.dev = function (msg) {
                console.log(msg);
            };
            // use it for hot reload
            // eslint-disable-next-line @typescript-eslint/no-require-imports,no-undef
            require('./root/Root.hot');

            // enable it and don't forget to add back render() function
            // module.exports = require('./Root.dev');
        } else {
            window.console.dev = function () {
            };
            // eslint-disable-next-line @typescript-eslint/no-require-imports,no-undef
            require('./root/Root.prod');
        }
    }
}
